import { Pagination } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

const ITEMS_PER_PAGE: number = 40;

interface GridPaginationProps {
  totalItems: number | undefined;
  baseRoute: string;
}

const GridPagination: React.FC<GridPaginationProps> = ({ totalItems = 0, baseRoute }) => {
  const { page } = useParams();
  const navigate = useNavigate();

  if (!totalItems || totalItems <= ITEMS_PER_PAGE) return <></>;

  const count = Math.ceil(totalItems / ITEMS_PER_PAGE);

  return (
    <Pagination
      className="pagination"
      count={count}
      showFirstButton
      showLastButton
      defaultPage={Number(page)}
      onChange={(_, page) => navigate(`${baseRoute}/${Number(page)}`)}
    />
  );
};

export default GridPagination;
